"use client";

import AngleRightIcon from "@/assets/icons/arrow-right.svg?react";
import HomeIcon from "@/assets/icons/home.svg?react";
import { CLink } from "@/components/common/customLink/CustomLink";
import { cn } from "@/lib/tailwind";

interface BreadcrumbProps {
  className?: string;
  items: BreadcrumbItem[];
}

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

const Breadcrumb = ({ className, items }: BreadcrumbProps) => {
  return (
    <div className={cn("container flex h-[54px] items-center", className)}>
      <div className="no-scrollbar flex items-center gap-1.5 overflow-x-auto text-sm text-tertiary-6">
        <CLink href="/" className="flex items-center">
          <HomeIcon
            style={{
              height: "0.75rem",
              width: "0.75rem",
            }}
          />
        </CLink>
        <div>
          <AngleRightIcon className="ml-2 h-2.5 w-2.5 text-tertiary-4" />
        </div>
        {items.map((item, idx) => {
          return (
            <div className="flex items-center pr-2" key={idx}>
              {item.path ? (
                <CLink href={item.path ?? ""} className="text-ellipsis whitespace-nowrap">
                  {item.label}
                </CLink>
              ) : (
                <p className="text-ellipsis whitespace-nowrap">{item.label}</p>
              )}
              {idx == items.length - 1 ? (
                <></>
              ) : (
                <AngleRightIcon className="ml-2 h-2.5 w-2.5 text-tertiary-4" />
              )}
            </div>
          );
        })}
      </div>

      {/* {loading && (
        <div className="ms-4 flex items-center gap-1.5">
          <CLink href="/">
            <HomeIcon className="h-4 w-4" />
          </CLink>
          <AngleRightIcon className="h-2.5 w-2.5 text-tertiary-4" />
          <Skeleton className="h-1 w-full bg-tertiary-5 md:w-[40%]" />
        </div>
      )} */}
    </div>
  );
};

export default Breadcrumb;
